__turbopack_context__.v({
  "blogSection": "BlogIndex-module-scss-module__V4Xg3G__blogSection",
  "blogSectionHeader": "BlogIndex-module-scss-module__V4Xg3G__blogSectionHeader",
  "blogsFeedContainer": "BlogIndex-module-scss-module__V4Xg3G__blogsFeedContainer",
  "description": "BlogIndex-module-scss-module__V4Xg3G__description",
  "mainContainer": "BlogIndex-module-scss-module__V4Xg3G__mainContainer",
  "numArticles": "BlogIndex-module-scss-module__V4Xg3G__numArticles",
  "title": "BlogIndex-module-scss-module__V4Xg3G__title",
});
